export default __webpack_public_path__ + "fe9fad35b9cc7d4553b9a00c84886639.png";